import React from 'react';
import { Button } from 'react-bootstrap-5';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHouseBuilding, faTrash } from '@fortawesome/pro-solid-svg-icons';
import EmptyState from '../empty_state';
import type { OwnedProperty } from 'bundles/connect/types';
import { setOffMarketPropertyId } from 'bundles/connect/components/store/actions/off_market_property';
import { connect } from 'react-redux';

type Props = {
  ownedProperties: OwnedProperty[];
  onDeleteOwnedProperty: (property: OwnedProperty) => void;
  setOffMarketPropertyId: (id: string) => void;
}

function OwnedPropertiesList({ ownedProperties, onDeleteOwnedProperty, setOffMarketPropertyId }: Props) {

  if (ownedProperties.length === 0) {
    return (
      <EmptyState
        icon={faHouseBuilding}
        text="This contact has no properties"
      />
    );
  }

  return (
    <>
      {ownedProperties.map(ownedProperty => (
        <div className="d-flex border-bottom justify-content-between p-2" key={ownedProperty.propertyId}>
          <span
            className="text-truncate fw-bolder clickable text-primary"
            onClick={() => setOffMarketPropertyId(ownedProperty.propertyId)}
          >
            {ownedProperty.address}, {ownedProperty.city}, {ownedProperty.state}
          </span>
          <Button
            variant="link"
            onClick={() => onDeleteOwnedProperty(ownedProperty)}
          >
            <FontAwesomeIcon className="text-danger" icon={faTrash} />
          </Button>
        </div>
      ))}
    </>
  );
}

export default connect(undefined, { setOffMarketPropertyId })(OwnedPropertiesList);
